module.exports = __webpack_public_path__ + "static/media/VIP_Pass@3x.1d5fde24.png";